__turbopack_context__.v({
  "dimmed": "slider-module-scss-module___Zx5Ja__dimmed",
  "hoverController": "slider-module-scss-module___Zx5Ja__hoverController",
  "pagination": "slider-module-scss-module___Zx5Ja__pagination",
  "wrapper": "slider-module-scss-module___Zx5Ja__wrapper",
});
